import { TrelloIcon } from '../../../assets/icons/trello';
import { createEmbedProvider } from '../factory';

/**
 * Trello URL regex pattern
 * Matches: trello.com/c/CARD_ID/... or trello.com/b/BOARD_ID/...
 * Captures the type (c or b) in group 1, object ID in group 2.
 */
export const TRELLO_REGEX = /^https:\/\/(?:www\.)?trello\.com\/(c|b)\/([^/?#]+)/;

export const trelloProvider = createEmbedProvider({
  id: 'trello',
  label: 'Trello',
  icon: <TrelloIcon className="size-5" />,
  regex: TRELLO_REGEX,
  buildEmbedUrl: (match) => {
    const type = match[1] === 'c' ? 'card' : 'board';

    return `https://trello.com/embed/${type}?id=${match[2]}`;
  },
  buildTitle: (url) => {
    const match = url.match(TRELLO_REGEX);
    if (!match) return 'Trello Embed';
    const type = match[1] === 'c' ? 'Card' : 'Board';

    return `Trello ${type} (${match[2]})`;
  },
});
